module.exports = __webpack_public_path__ + "img/tfuel.ad993ffc.svg";